import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import Icon from '../../../components/AppIcon';
import { IMAGE_VERSION } from '../../../version.js';

const MiStoreHero = () => {
  const { t } = useTranslation('store');
  return (
    <section className="relative py-16 lg:py-24 overflow-hidden" style={{ contain: 'paint' }}>
        
      <div className="absolute inset-0 bg-gradient-to-br from-background via-background to-secondary opacity-95 pointer-events-none"></div>
      <div className="absolute inset-0 bg-gradient-to-tr from-primary/20 via-transparent to-accent/10 pointer-events-none"></div>
      
      {/* Dark theme overlay for perfect text contrast */}
      <div className="absolute inset-0 hero-dark-overlay opacity-70 [data-theme='dark']:opacity-100 pointer-events-none"></div>
      
      {/* Background Elements */}
      <div className="absolute inset-0">
        <div className="absolute top-20 left-10 w-32 h-32 opacity-10">
          <svg viewBox="0 0 48 48" className="w-full h-full">
            <polygon 
              points="24,2 38,12 38,28 24,38 10,28 10,12" 
              fill="var(--color-accent)"
            />
          </svg>
        </div>
        <div className="absolute bottom-20 right-10 w-24 h-24 opacity-10">
          <svg viewBox="0 0 48 48" className="w-full h-full">
            <polygon 
              points="24,2 38,12 38,28 24,38 10,28 10,12" 
              fill="var(--color-surface)"
            />
          </svg>
        </div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-64 h-64 opacity-5">
          <svg viewBox="0 0 48 48" className="w-full h-full">
            <polygon 
              points="24,2 38,12 38,28 24,38 10,28 10,12" 
              fill="var(--color-primary)"
            />
          </svg>
        </div>
      </div>

      <div className="relative container mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <div className="inline-flex items-center justify-center mb-6">
            <div className="relative">
              <img 
                src={`/assets/images/logo2.png?ver=${IMAGE_VERSION}`}
                alt="PC Centar Logo" 
                width="64" 
                height="64" 
                className="object-contain rounded-xl shadow-lg border border-accent bg-white" 
                style={{ background: '#fff' }}
                loading="lazy"
                decoding="async"
              />
            </div>
          </div>
          
          <h1 className="font-heading font-bold text-4xl lg:text-6xl text-foreground mb-6">
            {t('hero.title', 'Xiaomi Store prodavnice')}
          </h1>
          
          <div className="flex flex-wrap justify-center gap-8 mt-12">
            <div className="text-center">
                <div className="text-3xl font-bold text-accent">8</div>
              <div className="text-sm text-text-secondary">{t('hero.locationsLabel', 'Xiaomi Store lokacija')}</div>
            </div>
            <div className="text-center">
                <div className="text-3xl font-bold text-success">6+</div>
              <div className="text-sm text-text-secondary">{t('hero.yearsLabel', 'Godina iskustva')}</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-warning">500+</div>
              <div className="text-sm text-text-secondary">{t('hero.productsLabel', 'IT proizvoda')}</div>
            </div>
          </div>
        </motion.div>
        {/* Call to Action Buttons */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="flex flex-col sm:flex-row gap-4 justify-center max-w-md mx-auto"
          >
            <button 
              onClick={() => window.open("https://mi-srbija.rs/", "_blank")}
              className="flex-1 px-6 py-3 bg-accent text-accent-foreground rounded-xl font-medium hover:bg-accent/90 transition-colors duration-300 flex items-center justify-center space-x-2 shadow-lg"
            >
              <Icon name="Store" size={20} />
              <span>{t('hero.webStore', 'Web Prodavnica')}</span>
            </button>
            <button 
              onClick={() => {
                // Scroll to map section
                const mapSection = document.querySelector('#stores-map');
                if (mapSection) {
                  mapSection.scrollIntoView({ behavior: 'smooth' });
                }
              }}
              className="flex-1 px-6 py-3 border border-accent text-accent rounded-xl font-medium hover:bg-accent/10 transition-colors duration-300 flex items-center justify-center space-x-2"
            >
              <Icon name="MapPin" size={20} />
              <span>{t('hero.findLocation', 'Pronađite lokaciju')}</span>
            </button>
          </motion.div>
      </div>
    </section>
  );
};

export default MiStoreHero;